import { create } from 'zustand';

export const useTicketTemplateStore = create((set) => ({
    templates: [],
    loading: false,
    error: null,
    selectedTemplate: null,
    reportFields: [],    // DevExpress bound fields for the linked report
    searchParams: { page: 1, pageSize: 10, search: '', status: '' },
    paginationData: { total: 0, totalPages: 0, page: 1, pageSize: 10 },
    columnFilters: {},
    uniqueValues: {},
    isFormOpen: false,
    isDeleteDialogOpen: false,
    isFieldBuilderOpen: false,
    isReportDesignerOpen: false,
    isReportFieldMapperOpen: false,

    setTemplates: (templates) => set({ templates }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSelectedTemplate: (t) => set({ selectedTemplate: t }),
    setReportFields: (reportFields) => set({ reportFields }),
    setSearchParams: (params) => set((s) => ({ searchParams: { ...s.searchParams, ...params } })),
    setPaginationData: (paginationData) => set({ paginationData }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),

    openCreateForm: () => set({ isFormOpen: true, selectedTemplate: null }),
    openEditForm: (t) => set({ isFormOpen: true, selectedTemplate: t }),
    closeForm: () => set({ isFormOpen: false }),
    openDeleteDialog: (t) => set({ isDeleteDialogOpen: true, selectedTemplate: t }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false }),
    openFieldBuilder: (t) => set({ isFieldBuilderOpen: true, selectedTemplate: t }),
    closeFieldBuilder: () => set({ isFieldBuilderOpen: false }),
    openReportDesigner: (t) => set({ isReportDesignerOpen: true, selectedTemplate: t }),
    closeReportDesigner: () => set({ isReportDesignerOpen: false }),
    openReportFieldMapper: (t) => set({ isReportFieldMapperOpen: true, selectedTemplate: t }),
    closeReportFieldMapper: () => set({ isReportFieldMapperOpen: false })
}));
